// TelcoTrack — photo download that follows HTTP redirects (presigned MinIO 302).
// When PHOTOS_PRESIGNED_DOWNLOAD is OFF, the API streams 200 and this is a normal GET.
// When ON, api-gateway passes through 302 Location → MinIO; browsers/fetch follow it.
// Prefer fetch over Angular HttpClient here so redirect:'follow' is explicit and CORS
// to MinIO is the same path the browser uses for <img src> thumbs.

/**
 * GET a photo URL (API download or absolute URL) as a Blob, following redirects.
 * Uses credentials for same-origin API auth cookies; not sent to cross-origin MinIO after 302.
 */
export async function fetchPhotoBlob(url: string, init?: RequestInit): Promise<Blob> {
  const res = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    redirect: 'follow',
    ...init,
  });
  if (!res.ok) {
    throw new Error(`Photo download failed: HTTP ${res.status}`);
  }
  return res.blob();
}
